import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../actions"

import { svgAsPngUri, download } from "save-svg-as-png";

const options = ['Add digital poster to cart - 5.00$', 'Add paper poster to cart - 35.00$', 'Free download (Low resolution)'];

export default function SplitButton() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const [disabledIndex, setDisabledIndex] = React.useState(null);
  //const [caption, setCaption] = React.useState('Free download (Low resolution)');

  const currentPoster = useSelector(state => state.poster);
  const dispatch = useDispatch();

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
    let poster = JSON.parse(JSON.stringify(currentPoster))
    switch (selectedIndex) {
      case 0:
        dispatch(addToCart({ poster, format: 'digital', id: 1, price: 5, category: 'poster' }));
        break;
      case 1:
        dispatch(addToCart({ poster, format: 'paper', id: 2, price: 35, category: 'poster' }));
        break;
      default:
        handleFreeDownload();
    }
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleFreeDownload = () => {
    options[2] = 'Processing...';
    setDisabledIndex(2)
    /*this.setState({
      freeDisabled: true,
      freeCaption: 'Processing...'
    })*/


    //saveSvgAsPng(document.getElementById("poster"), "map.png", { scale: 1, encoderOptions: 0.7 });
    //864x1152px = 12x16inch at 72DPI = scale : 1.8 (1152/640) where 640 = height of the poster on screen
    //432x576px = 6x8inch at 72DPI = scale : 0.9 (576/640) where 640 = height of the poster on screen

    svgAsPngUri(document.getElementById("poster"), { scale: 0.9, encoderOptions: 0.7 }, function (png) {
      var data = png.replace(/^data:image\/\w+;base64,/, '');
      if (global.serverUrl === 'http://localhost:5000') {
        download("map.png", png);
        /*st.setState({
          freeDisabled: false,
          freeCaption: 'Free Download (Low resolution)'
        })*/
        options[2] = 'Free Download (Low resolution)';
        setDisabledIndex(null)
      } else {
        fetch(global.serverUrl + '/mail', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({ data: data, format: "LowResolution" })
        })
          .then(function (res) {
            download("map.png", png);
            options[2] = 'Free Download (Low resolution)';
            setDisabledIndex(null)
          })
          .catch(function (res) { console.log(res) })
      }
    })


  }

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs={12}>
        <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
          <Button style={{ width: 520 }} onClick={handleClick}>{options[selectedIndex]}</Button>
          <Button
            color="primary"
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            //aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper style={{ width: 560 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        disabled={index === disabledIndex}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/components/AddCartButton.js